// src/components/TransferHistory.jsx
import React, { useState, useEffect } from 'react';
import JobsList from './JobsList';
import JobDetails from './JobDetails';
import './TransferHistory.css';
import { cloudTransferJobsAPI } from '../../../api';

const TransferHistory = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    success: 0,
    partialSuccess: 0,
    inProgress: 0,
    failed: 0
  });
  // QuickMenu state
  const [activeMenuItem, setActiveMenuItem] = useState('analytics');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      setLoading(true);
      const response = await cloudTransferJobsAPI.get('/jobs');
      const data = response.data;
      setJobs(data);
      calculateStats(data);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setLoading(false);
    }
  };

  const calculateStats = (jobsData) => {
    const stats = {
      total: jobsData.length,
      success: jobsData.filter(job => job.status === 'success').length,
      partialSuccess: jobsData.filter(job => job.status === 'partial_success').length,
      failed: jobsData.filter(job => job.status === 'failed').length,
      inProgress: jobsData.filter(job => job.status === 'in_progress').length,
    };
    setStats(stats);
  };

  const handleJobSelect = async (jobId) => {
    try {
      setLoading(true);
      const response = await cloudTransferJobsAPI.get(`/jobs/${jobId}`);
      setSelectedJob(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setLoading(false);
    }
  };

  const refreshData = () => {
    fetchJobs();
    if (selectedJob) {
      handleJobSelect(selectedJob.job_id);
    }
  };

  return (
    <>
        {/* QuickMenu Sidebar */}

    <div className="transfer-history-container">
      <header className="header">
        <h1>Cloud Transfer History</h1>
        <button className="refresh-btn" onClick={refreshData}>
          Refresh Data
        </button>
      </header>
      
      <div className="stats-panel">
        {/* <div className="stat-card total">
          <h3>Total Jobs</h3>
          <span>{stats.total}</span>
        </div> */}
        <div className="stat-card success">
          <h3>Success</h3>
          <span>{stats.success}</span>
        </div>
        <div className="stat-card in-progress">
          <h3>In Progress</h3>
          <span>{stats.inProgress}</span>
        </div>
        <div className="stat-card warning">
          <h3>Warning</h3>
          <span>{stats.partialSuccess}</span>
        </div>
        <div className="stat-card failed">
          <h3>Failed</h3>
          <span>{stats.failed}</span>
        </div>
      </div>

      {loading && <div className="loading">Loading...</div>}
      {error && <div className="error">Error: {error}</div>}
      
      <div className="content-area">
        <JobsList 
          jobs={jobs} 
          onJobSelect={handleJobSelect} 
          selectedJobId={selectedJob?.job_id}
        />
        {selectedJob 
        ? <JobDetails job={selectedJob} />
        : <div className="job-details">
            <div className="job-header">
              <h2>Job Details</h2>
            </div>
            <div style={{textAlign: 'center', marginTop: '20px'}}>
              No job selected. Please select a job to view details.
            </div>
        </div>
      }
      </div>
    </div>
    </>
  );
};

export default TransferHistory;